import * as React from 'react';
import { Spin } from 'antd';
import { styles } from './SuperLoaderStyles'

export default function SuperLoader(props) {
    return <div style={styles.div}>
                <Spin spinning={props.loading} tip={props.message}/>
            </div>
}
